import { connect } from 'react-redux'
import { withRouter } from 'react-router'

import SetNewPasswordForm from './SetNewPasswordForm';
import { ChakraBaseProvider, Flex, Box} from '@chakra-ui/react';
import claverTheme from '../../layout/components/layout/components/theme/claverTheme';
import GeneralPageFooter from './GeneralPageFooter';
import PublicUserHeader from './PublicUserHeader';
import { redirectToNewPage } from '../../global/helpers/global-helpers';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckShortLogo from '../../global/components/helper-components/components/LaunchdeckShortLogo';


function SetNewPasswordPage(props) {

		const resetPasswordToken = props.match.params.resetPasswordToken;
		const {updateStatus} = props.setNewPasswordOutcome || {};

		// Use Effect to query whether resetPasswordToken is valid

		const renderContent = () => {
			if (updateStatus === true) {
				return (
					<Box w='100%' maxW='25em'>
						<Flex my='1em' align='center' justify='center'>
							<LaunchdeckShortLogo boxSize='2.5em' />
						</Flex>
						<Box textAlign='center' fontSize='0.875em'>Your password has been reset. Try logging in with your new password now.</Box>
						<Flex align='center' justify='center' mt='2em'>
							<LaunchdeckButton fontSize='0.9em' py='0.8em' px='3em' bg='brand.500' color='white' onClick={() => redirectToNewPage('/login')} label='Log in' />
						</Flex>
					</Box>
				)
			} 

			if (updateStatus === false) {
				return (
					<Box w='100%' maxW='25em'>
						<Flex my='1em' align='center' justify='center'>
							<LaunchdeckShortLogo boxSize='2.5em' />
						</Flex>

						<Box my='1em' textAlign='center' fontSize='1.2em'>
							We've expired the request to set a new password
						</Box>
						<Box my='1em' textAlign='center' fontSize='0.9em'>
							Please request to change it again
						</Box>
						<Flex align='center' justify='center' mt='2em'>
						<LaunchdeckButton bg='gray.200' color='gray.700' onClick={() => redirectToNewPage('/login')} label='Go back' />

						</Flex>
					</Box>
				)
			} 

			if (updateStatus === undefined || !updateStatus) {
				return (
					<SetNewPasswordForm resetPasswordToken={resetPasswordToken} />
				)
			}
		}

		return (
			<ChakraBaseProvider theme={claverTheme}>
				<PublicUserHeader />
				<Box w='100%' px='1em' className="authentication-container">

					<Flex direction='column' h='100%' pb='2em'>

						<Flex w='100%' justify='center' py='5em'>
							<Flex className="default-box-shadow" maxW='35em' w='100%' direction='column' alignItems='center' bg='white' rounded='0.8em' py='2em'>
								{renderContent()}
							</Flex>

						</Flex>

						<GeneralPageFooter />

					</Flex>
				</Box>
			</ChakraBaseProvider>
		);
	
}


function mapStateToProps(state) {
  return {
    setNewPasswordOutcome: state.setNewPasswordOutcome.results.data,
  };
}


export default withRouter(connect(mapStateToProps, null)(SetNewPasswordPage));